"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchStrategy = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /*
 * Copyright (c) 2022, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/**
 * @private
 */
class FetchStrategy extends _react.default.Component {
  /**
   * @private
   */
  static initAppState(args) {
    var _this = this;
    return _asyncToGenerator(function* () {
      try {
        const promises = _this.getInitializers().map(fn => fn(args));
        return {
          error: undefined,
          appState: _extends({}, ...(yield Promise.all(promises)))
        };
      } catch (error) {
        return {
          error: error || new Error(),
          appState: {}
        };
      }
    })();
  }
}
exports.FetchStrategy = FetchStrategy;